/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LeiharbeitsverhaeltnisInputs */



/**

* @param {_Field_LeiharbeitsverhaeltnisInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_leiharbeitsverhaeltnis = /** @type {((inputs?: _Field_LeiharbeitsverhaeltnisInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LeiharbeitsverhaeltnisInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Leiharbeitsverhältnis")
});